import React from 'react';

import { useAuthNavigation } from '@/hooks';

import { AsyncWrapper } from '../common';

interface UserAuthGuardProps {
  children: React.ReactNode;
}

export const UserAuthGuard: React.FC<UserAuthGuardProps> = ({ children }) => {
  const { isLoading, error } = useAuthNavigation();

  // All checks passed
  return (
    <AsyncWrapper
      isLoading={isLoading}
      error={error ? 'Something went wrong while loading the page' : undefined}
    >
      <>{children}</>
    </AsyncWrapper>
  );
};
